import {
	Alert,
	Box,
	Button,
	Grid,
	Paper,
	Typography,
	TableCell,
	TableContainer,
	Table,
	TableBody,
	TableRow,
	Menu,
	MenuItem,
	Modal,
	Snackbar,
	Tooltip,
	FormControl,
	Select,
	TextField,
} from '@mui/material';
import '../Dashboard.css';
import WebLogo from '../../../../assets/logos/websitelogo.svg';
import React, { useEffect, useState } from 'react';
import { editVisitData } from '../../../services/api/apiManager';
import PropTypes from 'prop-types';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router';

function Patients({
	filteredVisits,
	setFilteredVisits,
	visitData,
	loading,
	getDataForAdmittedPatients,
	searchText,
	setSearchText,
	provider,
	location,
	handleProvider,
	handleLocation,
	locations,
	staffList,
	currentPage,
	rowsPerPage,
}) {
	Patients.propTypes = {
		visitData: PropTypes.array.isRequired,
		setVisitData: PropTypes.func.isRequired,
		filteredVisits: PropTypes.array.isRequired,
		setFilteredVisits: PropTypes.func.isRequired,
		loading: PropTypes.bool.isRequired,
		setLoading: PropTypes.func.isRequired,
		searchText: PropTypes.string.isRequired,
		setSearchText: PropTypes.func.isRequired,
		getVisitData: PropTypes.func.isRequired,
		getDataForAdmittedPatients: PropTypes.func.isRequired,
		provider: PropTypes.string.isRequired,
		location: PropTypes.string.isRequired,
		handleProvider: PropTypes.func.isRequired,
		handleLocation: PropTypes.func.isRequired,
		locations: PropTypes.array.isRequired,
		staffList: PropTypes.array.isRequired,
		currentPage: PropTypes.number.isRequired,
		rowsPerPage: PropTypes.number.isRequired,
	};

	// Modal
	const style = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 450,
		bgcolor: 'background.paper',
		border: '2px solid #000',
		borderRadius: '1rem',
		boxShadow: 24,
		p: 4,
	};

	const navigate = useNavigate();
	const [currentDate, setCurrentDate] = useState(new Date());
	const [anchorEl, setAnchorEl] = useState(null);
	const [selectedVisitId, setSelectedVisitId] = useState(null);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [openSnackbarDelete, setOpenSnackbarDelete] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [deleteId, setDeleteId] = useState();
	const handleOpenDeleteModal = (dID) => {
		setDeleteId(dID);
		setOpenDeleteModal(true);
	};
	const handleCloseDeleteModal = () => {
		setOpenDeleteModal(false);
		handleMenuClose();
	};

	// open snakbar delete
	const handleClickSnackbarDelete = () => {
		setOpenSnackbarDelete(true);
	};
	const handleCloseSnackbarDelete = () => {
		setOpenSnackbarDelete(false);
	};

	console.log('Current Date' + currentDate);

	const theme = {
		palette: {
			primary: {
				main: '#D7DBDD',
				light: '#6ec6ff',
			},
		},
		spacing: (factor) => `${8 * factor}px`,
	};

	const handleSearch = () => {
		if (searchText.trim() === '') {
			getDataForAdmittedPatients();
		} else {
			const filteredData = visitData?.filter((item) =>
				item?.Name?.toLowerCase().includes(searchText?.toLowerCase())
			);
			setFilteredVisits(filteredData);
		}
	};

	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			handleSearch();
		}
	};

	const getWeekDates = (date) => {
		const currentDay = date.getDay();
		const firstDayOfWeek = new Date(date);
		firstDayOfWeek.setDate(firstDayOfWeek.getDate() - currentDay);
		const weekDates = [...Array(7)].map((_, index) => {
			const date = new Date(firstDayOfWeek);
			date.setDate(date.getDate() + index);
			return date;
		});
		return weekDates;
	};

	const getAbbreviatedDayOfWeek = (date) => {
		const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		return daysOfWeek[date.getDay()];
	};

	const formatDate = (date) => {
		const monthNames = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];
		const month = monthNames[date.getMonth()];
		const year = date.getFullYear();
		return `W${getWeekNumber(date)} - ${month} ${year}`;
	};

	const getWeekNumber = (date) => {
		const oneJan = new Date(date.getFullYear(), 0, 1);
		const numberOfDays = Math.floor((date - oneJan) / (24 * 60 * 60 * 1000));
		const weekNumber = Math.ceil((date.getDay() + 1 + numberOfDays) / 7);
		return weekNumber;
	};

	const handleNextWeek = () => {
		const nextWeek = new Date(currentDate);
		nextWeek.setDate(nextWeek.getDate() + 7);
		setCurrentDate(nextWeek);
	};

	const handlePreviousWeek = () => {
		const previousWeek = new Date(currentDate);
		previousWeek.setDate(previousWeek.getDate() - 7);
		setCurrentDate(previousWeek);
	};

	const handleMenuOpen = (event, visitId) => {
		setAnchorEl(event.currentTarget);
		setSelectedVisitId(visitId);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleEditButton = () => {
		navigate('/editCharge', { state: { visit_ID: selectedVisitId } });
	};

	const table = (
		<TableContainer component={Paper}>
			<Table>
				<TableBody>
					{/* Row for the calendar */}
					<TableRow
						sx={{
							'& .MuiTableCell-root': {
								padding: '5px',
								paddingBottom: '0px',
							},
							'& .MuiTableCell-root': {
								paddingBottom: '0px',
							},
						}}
					>
						<TableCell sx={{ display: 'flex', gap: '5px' }}>
							{' '}
							<TextField
								size="small"
								placeholder="Search by Patient Name"
								sx={{ ml: 1, flex: 1 }}
								value={searchText}
								onChange={(e) => setSearchText(e.target.value)}
								onKeyDown={handleKeyPress}
							/>
							<Button
								size="small"
								onClick={handleSearch}
								sx={{
									fontFamily: 'Poppins',
									color: 'white',
									background: '#FD7702',
									border: '1px solid #FD7702',
									fontSize: '14px',
									fontWeight: '600',
									'&:hover': {
										border: '1px solid #FD7702',
										color: '#FD7702',
										background: '#FFF3E8',
										background: 'white',
									},
								}}
							>
								Search
							</Button>
						</TableCell>
						{getWeekDates(currentDate).map((date, index) => (
							<TableCell key={index} sx={{ textAlign: 'center' }}>
								<h3 style={{ fontFamily: 'Poppins', fontWeight: 500 }}>
									{getAbbreviatedDayOfWeek(date)}/{/* <br /> */}
									<span style={{ fontWeight: 'bold' }}>{date.getDate()}</span>
								</h3>
							</TableCell>
						))}
					</TableRow>
					{/* Patients data */}
					{filteredVisits
						?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
						?.map((item, index) => {
							return (
								<TableRow
									key={item?.patient_id}
									sx={{
										'& .MuiTableCell-root': {
											padding: '5px',
										},
									}}
								>
									<TableCell style={{ width: '350px' }}>
										{/* Patient details */}
										<div
											style={{
												backgroundColor: '#E2F5F9',
												display: 'flex',
												justifyContent: 'space-between',
											}}
										>
											<div
												style={{
													display: 'flex',
													gap: '0.5rem',
													alignItems: 'center',
												}}
											>
												<Typography
													variant="body2"
													sx={{
														letterSpacing: 0.5,
														fontFamily: 'Poppins',
														color: '#075AD7',
														fontSize: '13px',
														fontWeight: '600',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														overflow: 'hidden',
													}}
												>
													{item?.Name}
												</Typography>
												<Typography
													variant="body2"
													sx={{
														letterSpacing: 0.5,
														fontFamily: 'Poppins',
														color:
															item?.Inactive === null ||
															item?.Inactive === false
																? '#2D7E38'
																: 'red',
														fontSize: '10px',
														fontWeight: '600',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														overflow: 'hidden',
													}}
												>
													{item?.Inactive === null || item?.Inactive === false
														? '(Active)'
														: '(InActive)'}
												</Typography>
											</div>
											<Typography
												variant="body2"
												sx={{
													letterSpacing: 0.5,
													fontFamily: 'Poppins',
													color: '#263238',
													fontSize: '11px',
													fontWeight: '600',
													whiteSpace: 'nowrap',
													textOverflow: 'ellipsis',
													overflow: 'hidden',
												}}
											>
												{item?.age}
											</Typography>
											<Typography
												variant="body2"
												style={{
													letterSpacing: '0.5px',
													fontFamily: 'Poppins',
													fontSize: '12px',
													fontWeight: '600',
												}}
											>
												MRN#{' '}
												<span
													style={{
														letterSpacing: '0.5px',
														fontFamily: 'Poppins',
														color: '#263238',
														fontSize: '12px',
														fontWeight: '600',
													}}
												>
													{item?.MRN}
												</span>
											</Typography>
										</div>
										<div
											style={{
												display: 'flex',
												justifyContent: 'space-between',
											}}
										>
											<div>
												<Typography
													variant="body2"
													sx={{
														fontFamily: 'Poppins',
														fontSize: '12px',
														color: '#000000',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														overflow: 'hidden',
														fontWeight: '600',
													}}
												>
													DOB:{' '}
													<span style={{ fontWeight: 'normal' }}>
														{new Date(
															item?.DOB?.split('T')[0]
														).toLocaleDateString('en-US', {
															month: 'short',
															day: '2-digit',
															year: 'numeric',
														})}
													</span>
												</Typography>

												<Typography
													variant="body2"
													sx={{
														fontFamily: 'Poppins',
														fontSize: '12px',
														color: '#000000',
														fontWeight: '600',
														whiteSpace: 'nowrap',
														textOverflow: 'ellipsis',
														overflow: 'hidden',
														width: '180px',
													}}
												>
													Provider Name:{' '}
													<Tooltip
														title={item?.provider}
														slotProps={{
															popper: {
																modifiers: [
																	{
																		name: 'offset',
																		options: {
																			offset: [0, -14],
																		},
																	},
																],
															},
														}}
														arrow
														placement="top"
													>
														<span
															style={{
																fontWeight: 'normal',
																textOverflow: 'ellipsis',
																overflow: 'hidden',
																whiteSpace: 'nowrap',
															}}
														>
															{item?.provider}
														</span>
													</Tooltip>
												</Typography>
											</div>
											<div
												style={{
													display: 'flex',
													alignItems: 'flex-end',
													flexDirection: 'column',
												}}
											>
												<div style={{ display: 'flex' }}>
													<Typography
														variant="body2"
														sx={{
															fontFamily: 'Poppins',
															fontSize: '12px',
															color: '#000000',
															fontWeight: '600',
															whiteSpace: 'nowrap',
															textOverflow: 'ellipsis',
															overflow: 'hidden',
															// width: '170px',
														}}
													>
														location:{' '}
													</Typography>
													<Tooltip
														title={item?.location}
														arrow
														placement="top"
														slotProps={{
															popper: {
																modifiers: [
																	{
																		name: 'offset',
																		options: {
																			offset: [0, -14],
																		},
																	},
																],
															},
														}}
													>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontSize: '12px',
																color: '#2081B8',
																fontWeight: '600',
																whiteSpace: 'nowrap',
																textOverflow: 'ellipsis',
																overflow: 'hidden',
																width: '70px',
															}}
														>
															{item?.location}
														</Typography>
													</Tooltip>
												</div>
												<div>
													<Typography
														variant="body2"
														sx={{
															fontFamily: 'Poppins',
															fontSize: '12px',
															color: '#000000',
															fontWeight: '600',
															whiteSpace: 'nowrap',
															textOverflow: 'ellipsis',
															overflow: 'hidden',
														}}
													>
														Adm Date:{' '}
														<span style={{ fontWeight: 'normal' }}>
															{item?.Admission_date
																? new Date(
																		item?.Admission_date
																	).toLocaleDateString()
																: ''}
														</span>
													</Typography>
												</div>
											</div>
										</div>
									</TableCell>
									{getWeekDates(currentDate).map((date, index) => {
										const formattedDate = date?.toISOString()?.split('T')[0];
										const isVisit = item?.visits?.some(
											(visit) =>
												visit?.VisitDate?.split('T')[0] === formattedDate
										);
										const visit = item?.visits?.find(
											(visit) =>
												visit?.VisitDate?.split('T')[0] === formattedDate
										);
										const isAdmitted =
											item?.Admission_date?.split('T')[0] === formattedDate;
										const isDischarged =
											item?.discharge_date?.split('T')[0] === formattedDate;
										const isPastDate =
											new Date(formattedDate) < new Date().setHours(0, 0, 0, 0);
										const startDate =
											new Date(formattedDate) >
											new Date(item?.Admission_date).setHours(0, 0, 0, 0);
										const discharged =
											new Date(formattedDate) >
											new Date(item?.discharge_date).setHours(0, 0, 0, 0);
										let hasVisit = false;
										let isGapText = true;
										if (isVisit) {
											hasVisit = true;
										}
										let content;
										if (isVisit) {
											content = 'Visit';
										} else if (isAdmitted) {
											content = 'Admitted';
										} else if (isDischarged) {
											content = 'Discharged';
										} else if (isAdmitted && isVisit) {
											content = 'Admitted/Visit';
										} else {
											if (isGapText && startDate && discharged && isPastDate) {
												content = 'Gap';
											} else {
												content = '';
											}
										}
										return (
											<TableCell
												key={index}
												style={{
													border: `1px solid ${theme.palette.primary.main}`,
													// padding: theme.spacing(1),
													textAlign: 'center',
													cursor:
														content == 'Visit' ||
														content == 'Gap' ||
														content == 'Admitted'
															? 'pointer'
															: '',
													backgroundColor:
														content == 'Admitted'
															? '#EAEEF8'
															: content == 'Visit'
																? '#EDFFF4'
																: content == 'Discharged'
																	? '#FFFBEF'
																	: content == 'Gap'
																		? '#FDEAEA'
																		: '',
												}}
												onClick={
													isVisit
														? (event) => handleMenuOpen(event, visit?.id)
														: (isGapText && content == 'Gap') ||
															  content == 'Admitted'
															? () =>
																	navigate('/newCharge', {
																		state: {
																			patient_id: item?.patient_id,
																			visit_date: date?.toISOString(),
																		},
																	})
															: null
												}
											>
												{content === 'Gap' || content === 'Admitted' ? (
													<Tooltip title="Add Charge">
														<Typography
															style={{ fontWeight: 'bold', fontSize: '13px' }}
														>
															<span>{content}</span>
														</Typography>
													</Tooltip>
												) : (
													<Typography
														style={{ fontWeight: 'bold', fontSize: '13px' }}
													>
														<span>{content}</span>
													</Typography>
												)}
												<Menu
													anchorEl={anchorEl}
													open={Boolean(
														anchorEl && selectedVisitId == visit?.id
													)}
													onClose={handleMenuClose}
													elevation={1}
												>
													<MenuItem onClick={handleEditButton}>Edit</MenuItem>
													<MenuItem
														onClick={() => handleOpenDeleteModal(visit?.id)}
													>
														Delete
													</MenuItem>
												</Menu>
											</TableCell>
										);
									})}
								</TableRow>
							);
						})}
				</TableBody>
			</Table>
		</TableContainer>
	);

	const handleDeleteUser = async (id, data) => {
		const response = await editVisitData(id, data);
		if (response.status === 200) {
			setPostSucessfully(true);
			getDataForAdmittedPatients();
			handleMenuClose();
		} else {
			setPostSucessfully(false);
		}
		setOpenDeleteModal(false);
		handleClickSnackbarDelete();
	};

	// Update discharged status of patients
	useEffect(() => {
		filteredVisits?.forEach((date) => {
			if (
				date?.discharge_date &&
				new Date(date?.discharge_date) <= currentDate
			) {
				date.discharged = true;
			}
		});
	}, [currentDate]);

	const mappingProviderList =
		staffList &&
		staffList?.map((row) => ({
			name: row.Lname + ' , ' + row.Fname,
			providerId: row.id,
		}));

	useEffect(() => {
		const handleClick = (event) => {
			if (anchorEl && !anchorEl.contains(event.target)) {
				handleMenuClose();
			}
		};

		document.body.addEventListener('click', handleClick);

		return () => {
			document.body.removeEventListener('click', handleClick);
		};
	}, [anchorEl]);

	return (
		<Grid
			container
			item
			xs={12}
			sm={12}
			md={12}
			lg={12}
			xl={12}
			sx={{ border: '1px solid #00000026' }}
		>
			<Grid
				container
				item
				xs={12}
				sm={12}
				md={12}
				lg={12}
				xl={12}
				sx={{
					padding: '8px',
					background: '#2081B8',
					fontFamily: 'Poppins',
					fontSize: '21px',
					fontWeight: '600',
					color: 'white',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<h5 style={{ marginLeft: 0, fontSize: '18px', fontWeight: '500' }}>
					Patients
				</h5>
				<div
					style={{
						margin: 'auto',
						display: 'flex',
						alignItems: 'center',
						textAlign: 'center',
					}}
				>
					{/* <Button>

					</Button> */}
					<ArrowBackIosNewIcon
						onClick={handlePreviousWeek}
						style={{ cursor: 'pointer' }}
					/>
					<p style={{ fontSize: '15px' }}>{formatDate(currentDate)}</p>
					<ArrowForwardIosIcon
						onClick={handleNextWeek}
						style={{ cursor: 'pointer' }}
					/>
				</div>
				<Grid item gap={'5px'} display={'flex'}>
					<FormControl
						variant="standard"
						sx={{
							minWidth: 180,
						}}
						size="small"
					>
						<Select
							value={provider}
							onChange={handleProvider}
							displayEmpty
							disableUnderline
							sx={{
								border: '2px solid #DA8541',
								borderLeft: '6px solid #DA8541',
								borderRadius: '6px',
								'&.MuiInput-underline:before': {
									borderBottom: 'none',
								},
								'&.Mui-focused': {
									'&.MuiInput-underline:before': {
										borderBottom: 'none',
									},
								},
								'&.Mui-hover': {
									'&.MuiInput-underline:before': {
										borderBottom: 'none',
									},
								},
								boxShadow:
									'0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 0 rgba(0, 0, 0, 0.19)',
								padding: '5px',
								color: 'white',
							}}
							MenuProps={{
								PaperProps: {
									style: {
										width: '8.3%',
										height: '25%',
										overflowY: 'scroll',
										overflowX: 'scroll',
									},
								},
							}}
						>
							<MenuItem value="">Provider</MenuItem>
							{mappingProviderList &&
								mappingProviderList.length > 0 &&
								mappingProviderList.map((pl, index) => (
									<MenuItem key={index} value={pl.providerId}>
										{pl?.name}
									</MenuItem>
								))}
						</Select>
					</FormControl>
					<FormControl variant="standard" sx={{ minWidth: 180 }} size="small">
						<Select
							value={location}
							onChange={handleLocation}
							displayEmpty
							disableUnderline
							sx={{
								border: '2px solid #DA8541',
								borderLeft: '6px solid #DA8541',
								borderRadius: '6px',
								'&.MuiInput-underline:before': {
									borderBottom: 'none',
								},
								'&.Mui-focused': {
									'&.MuiInput-underline:before': {
										borderBottom: 'none',
									},
								},
								'&.Mui-hover': {
									'&.MuiInput-underline:before': {
										borderBottom: 'none',
									},
								},
								boxShadow:
									'0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 0 rgba(0, 0, 0, 0.19)',
								padding: '5px',
								color: 'white',
							}}
							MenuProps={{
								PaperProps: {
									style: {
										width: '8.3%',
										height: '25%',
										overflowY: 'scroll',
										overflowX: 'scroll',
									},
								},
							}}
						>
							<MenuItem value="">Location</MenuItem>
							{locations?.map((items, index) => {
								return (
									<MenuItem key={index} value={items?.id}>
										{items?.Name}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
			</Grid>

			{loading ? (
				// <CircularProgress />
				<div
					style={{
						display: 'flex',
						height: '80vh',
						width: '90vw',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<div className="logo-container">
						<img className="logo" src={WebLogo} alt="Website Logo" />
					</div>
				</div>
			) : (
				<Grid
					item
					container
					xs={12}
					sm={12}
					md={12}
					lg={12}
					xl={12}
					sx={{
						height: {
							xl: '75vh',
							lg: '70vh',
							md: '60vh',
							sm: '80vh',
							xs: '80vh',
						},
						overflow: 'auto',
					}}
				>
					<Box sx={{ width: '100%' }}>
						{filteredVisits && filteredVisits.length <= 0 ? (
							<Typography
								sx={{
									width: '100%',
									height: '100%',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									color: 'red',
									letterSpacing: 5,
								}}
							>
								No Records
							</Typography>
						) : (
							table
						)}
					</Box>
				</Grid>
			)}
			{/* Modal Delete visit */}
			<Modal
				open={openDeleteModal}
				onClose={handleCloseDeleteModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box display={'flex'} flexDirection={'column'} gap={'1rem'}>
						<Typography
							id="modal-modal-title"
							variant="h6"
							align="center"
							fontWeight={'bold'}
							component="h2"
						>
							Are You Sure To Delete Visit?
						</Typography>
						<Box display={'flex'} justifyContent={'center'} gap={'14px'}>
							<Button
								variant="contained"
								sx={{ bgcolor: '#ED2828', width: '130px', py: '10px' }}
								onClick={handleCloseDeleteModal}
							>
								Cancel
							</Button>
							<Button
								variant="contained"
								sx={{ bgcolor: '#FD7702', width: '130px', py: '10px' }}
								onClick={() => {
									handleDeleteUser(deleteId, { Deleted: true });
								}}
							>
								Delete
							</Button>
						</Box>
					</Box>
				</Box>
			</Modal>
			<Snackbar
				open={openSnackbarDelete}
				autoHideDuration={2000}
				onClose={handleCloseSnackbarDelete}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={handleCloseSnackbarDelete}
					severity={!postSucessfully ? 'error' : 'success'}
					variant="filled"
					sx={{
						width: '100%',
						height: '3.5rem',
						textAlign: 'center',
						fontSize: '1.1rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={handleCloseSnackbarDelete}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '13px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{!postSucessfully ? 'Error' : 'Delete Charge Successfully!'}
				</Alert>
			</Snackbar>
		</Grid>
	);
}

export default Patients;
